import script from "./EditCorporateView.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCorporateView.vue?vue&type=script&setup=true&lang=js"

import "./EditCorporateView.vue?vue&type=style&index=0&id=90c5c910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90c5c910"]])

export default __exports__